import { render, staticRenderFns } from "./MainCalendar.vue?vue&type=template&id=4489a363&"
import script from "./MainCalendar.vue?vue&type=script&lang=js&"
export * from "./MainCalendar.vue?vue&type=script&lang=js&"
import style0 from "./MainCalendar.vue?vue&type=style&index=0&id=4489a363&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports